module.exports = __webpack_public_path__ + "img/frog.4dad600a.gif";